import slice from "./cubeSlice";

export default slice.reducer;
